import React, { useEffect, useState , useRef } from 'react'
import mainlogo from "../../assets/images/main-logo.svg"
import microsoft from "../../assets/images/microsoft.svg"
import google from "../../assets/images/google.svg"
import apple from "../../assets/images/apple-icon.svg"
import { Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup';
import { ErrorMessage } from '@hookform/error-message';
import useMakeRequest from '../utils/ApiHelper'
import { ApiConstants } from '../constants/ApiConstants'
import { useNavigate } from 'react-router-dom'
import { handleBackspaceAndEnter, saveToStorage } from '../utils/Helper'
import ResetPasswordValidation from '../Validation/ResetPassword'
import { LanguageConstants } from '../constants/LanguageConstants'


interface FormInputs {
confirm_password: string;
  password: string;
};
function ResetPassword(props:any) {
  const ResetPassword = useMakeRequest()
  const [show, setShow] = useState(false)
  const [cshow , setCshow] = useState(false)

  const { register, watch, setValue, formState: { errors }, handleSubmit } = useForm<FormInputs>({
    mode: 'onChange',
    resolver: yupResolver(ResetPasswordValidation),
  });
  
  const onSubmit = (data: FormInputs) => {
    const payload ={
        email:props?.email,
        otp:props?.OTP?.join(""),
        verify_type:"FORGOT_PASSWORD",
        password:data.password
    }
    ResetPassword.makeRequest({ payload, url: ApiConstants?.ResetPassword, toastStatus: true })
  }

  useEffect(()=>{
   if(ResetPassword?.status){
    props?.setShowFalse()   }
  },[ResetPassword])

  return (
    <>
        <div className="modal fade auth-modal text-center show" id="forgotPassModal" aria-labelledby="forgotPassModalLabel" aria-hidden="false" style={{ display: 'block' }} >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <button type="button"  className="btn-close" onClick={()=>props?.setShowFalse()} data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square"></i></button>
             
              <div className="modal-body pb-5">
                <h5 className="auth-modal-ttl">{LanguageConstants?.RESET_PASSWORD}</h5>
                <div className='mb-4'>
                <div className="com-floating">
                  <i className="f-icon icon-lock"></i>
                  <label className="f-label">{LanguageConstants?.PASSWORD} <span className="must-star">*</span></label>
                  <input className="f-input ps-5" type={show ? "text" : 'password'}  placeholder={LanguageConstants?.PASSWORD}   {...register('password')} />
                  <i className={ show ? "f-pass icon-eye-open" : "f-pass icon-eye-slash-fill"} onClick={()=>setShow(!show)}></i>
                </div>
                  <ErrorMessage
                  errors={errors}
                  name="password"
                  render={({ message }) => <p className='text-error text-start'>{message}</p>}
                />
                </div>
                <div className='mb-4'>
                <div className="com-floating">
                  <i className="f-icon icon-lock"></i>
                  <label className="f-label">{LanguageConstants?.Confirm_Password}<span className="must-star">*</span></label>
                  <input className="f-input ps-5" type={cshow ? "text" : 'password'}  placeholder={LanguageConstants?.Confirm_Password} {...register('confirm_password')}  />
                  <i className={cshow ?  "f-pass icon-eye-open" : "f-pass icon-eye-slash-fill"} onClick={()=>setCshow(!cshow)}></i>
                </div>
                  <ErrorMessage
                  errors={errors}
                  name="confirm_password"
                  render={({ message }) => <p className='text-error text-start'>{message}</p>}
                />
                </div>
                <button type="submit" disabled={ResetPassword.loading ? true : false}  className="auth-modal-btn round-btn mt-0 mb-4" data-bs-dismiss="modal" onClick={handleSubmit(onSubmit)} >{LanguageConstants?.SUBMIT}</button>
                {/* <p className="auth-modal-small-txt mb-0 note"><b>NOTE:</b> if the user changes the password, The user will be auto logout form all the devices on which the user has logged in with old password</p> */}
              </div>
            </div>
          </div>
        </div>
    </>
  )
}

export default ResetPassword